import { Node } from "../Node";

export interface INodeProvider<TValue = unknown> {

    node(): Node<TValue>;
}

export function isNodeProvider(obj: unknown): obj is INodeProvider {
    return obj && typeof (obj) == "object" && typeof (obj["node"]) == "function";
} 